module.exports = __webpack_public_path__ + "static/media/undraw_medical_research_qg4d.642ef1c7.svg";